import React, { Component } from 'react';
import './appointments.scss';
import StaffSelectorComponent from './staff-selector.component';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { convertGuidToInt } from '../../common/number-utils';
import * as schedulerActions from '../../scheduler/mySchedule/mySchedule.actions';
import { LoadingPane } from '@social-solutions/ssg-forms';
import NoCaseWorkersSplashPage from './no-case-workers-splash-page.component';

export class RequestAppointmentComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedStaffId: null,
      staffList: null,
      notification: null,
      whenValidationError: null,
      loading: true,
      loadingError: null,
    }
  }

  componentWillMount() {
    const { schedulerActions, auth } = this.props;

    const { currentSession } = auth;
    const { user } = currentSession || {};
    const { externalId: participantIdHex } = user || {};
    const participantId = convertGuidToInt(participantIdHex);

    schedulerActions.getStaffList(participantId)
      .then((data) => {
        if (data.value) {
          this.setState({
            staffList: data.value,
            loading: false,
          })  
        }
        else {
          this.setState({
            loadingError: 'There was an error retrieving case workers.'
          })
        }
      })
  }

  handleStaffSelection(staffId) {
    const { schedulerActions } = this.props;

    this.setState({
      selectedStaffId: parseInt(staffId, 10)
    });

    schedulerActions.getStaffAvailability(staffId).then((data) => {
      const queried_element_token = data.value.element_token;
      const queried_sub_id = data.value.sub_ids[0];

      const availabilityViewer = window.CronofyElements.AvailabilityViewer({
        target_id: "staff-availability-calendar",
        element_token: queried_element_token,
        availability_query: {
          participants: [
            {
              required: "all",
              members: [
                { sub: queried_sub_id }
              ]
            }
          ],
          required_duration: { minutes: 60 },
          query_periods: [
            { start: "2021-06-24T09:00:00Z", end: "2021-06-24T17:00:00Z" },
            { start: "2021-06-25T09:00:00Z", end: "2021-06-25T17:00:00Z" },
            { start: "2021-06-26T09:00:00Z", end: "2021-06-26T17:00:00Z" },
            { start: "2021-06-27T09:00:00Z", end: "2021-06-27T17:00:00Z" }
          ],
        },
        config: {
          start_time: "09:00",
          end_time: "15:30",
          interval: 15,
          mode: "free_select",
        },
        styles: {
          prefix: "staff-availability-viewer",
          colors: {
            available: "#20907f",
            hairline: "#CCCCCC",
          }

        },
        callback: notification => this.appointmentCallback(notification),
      });

      availabilityViewer.refresh();
    });
  }

  appointmentCallback = (element) => {
    const { notification = null } = element || {};
    const { query_periods = null } = notification || {};

    if (query_periods && query_periods.length > 0) {
      if (query_periods.length > 1) {
        this.setState({ whenValidationError: true });
        const times = { startTime: null, endTime: null };
        this.setState({ notification: times });
        this.compileAppointment(null);
      } else {
        const { start, end } = query_periods[0];
        this.setState({ whenValidationError: false });
        const times = { startTime: start, endTime: end };
        this.setState({ notification: times });
        this.compileAppointment(null);
      }
    } else {
      const times = { startTime: null, endTime: null };
      this.setState({ notification: times });
      this.compileAppointment(null);
    }
  }

  handleTextChange = (event) => {
    const value = event.target.value;
    this.compileAppointment(value);
  }

  renderDescriptionInput() {
    return (
      <div className='reason-for-request-container'>
        <span className='request-appointment-reason-text'>Why?</span>
        <p>Tell us a little about why you are scheduling this appointment.</p>
        <textarea onChangeCapture={(e) => this.handleTextChange(e)} />
      </div>
    )
  }

  renderStaffAvailability() {
    return (
      <section className='staff-availability-container'>
        <div className='staff-availability-text-container'>
          <div className='staff-availability-header'>When?</div>
          <p>Select an available date and time below. <span className='required-field-span'>*</span></p>
          <hr />
        </div>
        <div id='staff-availability-calendar' />
      </section>
    )
  }

  compileAppointment = (value) => {
    const { selectedStaffId, staffList, notification, whenValidationError } = this.state;

    const { auth, handleAppointment } = this.props;
    const { currentSession } = auth;
    const { user } = currentSession || {};
    const { externalId: participantIdHex } = user || {};

    const participantId = convertGuidToInt(participantIdHex);
    const participantName = `${user.firstName} ${user.lastName}`;

    const selectedStaff = staffList.find(s => s.userId === selectedStaffId);
    const selectedStaffName = `${selectedStaff.firstName} ${selectedStaff.lastName}`;

    const appointment = {
      currentStaff: [],
      currentSubject: [],
      description: value,
      endTime: null,
      externalId: "",
      includeVideo: false,
      invitationTime: null,
      location: "",
      staffInvitees: [{
        calendarStaffId: selectedStaffId,
        email: selectedStaff.userName,
        invitation: {
          requried: true
        },
        isOrganizer: false,
        name: selectedStaffName
      }],
      startTime: null,
      subjectInvitees: [
        {
          email: user.email,
          invitation: {
            required: true
          },
          name: participantName,
          subjectId: participantId,
          type: "PARTICIPANT"
        }
      ],
      title: `Appt with ${participantName} and ${selectedStaffName}`,
      type: {
        id: 1,
        type: "Appointment"
      }
    };

    if (!!selectedStaffId) {
      appointment.staffInvitees[0].calendarStaffId = selectedStaffId;
    }

    if (value !== null) {
      appointment.description = value;
    } else if (value === null) {
      appointment.description = '';
    }

    if (!!notification) {
      appointment.startTime = notification.startTime;
      appointment.endTime = notification.endTime;
      appointment.invitationTime = notification.startTime;
    }

    handleAppointment(appointment, whenValidationError);
  }

  render() {
    const { selectedStaffId, staffList, whenValidationError } = this.state;
    const { loadingError, loading } = this.state;

    return (
      <div className='request-appointment-container'>
        
        <LoadingPane 
          loadingMessage="Loading Case Workers..." 
          loadingState={{ 
            isLoading: loading,
            error: loadingError ? {
              alertLevel: 'error',
              errorCode: 'error',
              errorMessage: loadingError,
            } : null
          }} />
            { !loading &&
              <div>
                  { staffList.length > 0 ?
                    <div>
                      <section className='staff-selector-container'>
                        <StaffSelectorComponent
                          setStaffSelection={(val) => this.handleStaffSelection(val)}
                          staffList={staffList}
                        />
                      </section>
                      {selectedStaffId !== null && selectedStaffId !== 'none' && this.renderStaffAvailability()}
                      {whenValidationError ? <div className="error">Please only add one time period per appointment</div> : null}
                      {selectedStaffId !== null && selectedStaffId !== 'none' && this.renderDescriptionInput()}
                    </div> :
                    <NoCaseWorkersSplashPage />
                  }
              </div>
            }
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    schedulerActions: bindActionCreators(schedulerActions, dispatch)
  }
}

const mapStateToProps = ({ appointment, auth }) => {
  return {
    appointment,
    auth
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestAppointmentComponent);



// WEBPACK FOOTER //
// src/dashboard/appointments/request-appointment.component.js